<app-pat-payment-panel-paygreen-generic
  type="PAYGREEN_RESTOFLASH"
></app-pat-payment-panel-paygreen-generic>
